import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { jsonForm, visibilityType } from '@europrocurement/flexy-form/utils/types/formTypes';
import { type CustomOptionResolvers } from '@europrocurement/flexy-form';

import type JsonForm from '../../JsonForm';

export type GestionEtablissementModalProps = {
    onChange: (currentPage: number, pageLength: number, data?: Record<string, unknown>) => void;
    json: jsonForm;
    defaultValues: Record<string, unknown>;
    customOptionResolvers: CustomOptionResolvers;
    visibility?: visibilityType;
    showCancelFermeture?: boolean;
};

const GestionEtablissementModal: React.FunctionComponent<GestionEtablissementModalProps> =
    function ({
        onChange,
        json,
        defaultValues,
        customOptionResolvers,
        visibility,
        showCancelFermeture = false,
    }: GestionEtablissementModalProps) {
        const [currentValues, setCurrentValues] = useState(defaultValues);
        const [formKey, setFormKey] = useState(0);

        const handleCancelFermeture = () => {
            const resetValues = {
                ...currentValues,
                personneMorale: {
                    ...((currentValues.personneMorale as Record<string, unknown>) ?? {}),
                    autresEtablissements: {
                        ...(((currentValues.personneMorale as Record<string, unknown>)
                            ?.autresEtablissements as Record<string, unknown>) ?? {}),
                        descriptionEtablissement: {
                            ...(((
                                (currentValues.personneMorale as Record<string, unknown>)
                                    ?.autresEtablissements as Record<string, unknown>
                            )?.descriptionEtablissement as Record<string, unknown>) ?? {}),
                            dateEffetFermeture: null,
                            destinationEtablissement: null,
                            autreDestination: null,
                        },
                        effectifSalarie: {
                            dateCessationEmploiSalaries: null,
                        },
                    },
                },
            };
            setCurrentValues(resetValues);
            setFormKey((k) => k + 1);
            onChange(0, 1, resetValues);
        };

        return (
            <Box sx={{ width: '60%', margin: 'auto' }}>
                {showCancelFermeture && (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            marginBottom: '16px',
                            paddingTop: '16px',
                        }}
                    >
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={handleCancelFermeture}
                            sx={{
                                borderRadius: '10px',
                                padding: '10px 20px',
                                fontWeight: 'bold',
                                textTransform: 'none',
                            }}
                        >
                            Annuler le transfert de cet établissement
                        </Button>
                    </Box>
                )}
                <JsonForm
                    key={formKey}
                    onChange={onChange}
                    visibility={visibility || 'FULL'}
                    debugMode={false}
                    json={json as jsonForm}
                    startPage={0}
                    defaultValues={currentValues}
                    customOptionResolvers={customOptionResolvers}
                    submitLabel="Enregistrer les informations"
                    submitStyle={{
                        marginTop: '30px',
                        padding: '20px 25px',
                        fontSize: '1rem',
                        borderRadius: '15px',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}
                />
            </Box>
        );
    };

export default GestionEtablissementModal;
